import { Dropdown } from "react-bootstrap";
import SelectMenu from "./SelectMenu";

interface IProps {
  name: string;
  data: string[];
  setColumnFiltered: () => void;
  setFilterValue: (a: string) => void;
}

const DropdownSelector: React.FC<IProps> = ({
  name,
  data,
  setColumnFiltered,
  setFilterValue,
}: IProps) => {
  return (
    <>
      <Dropdown
        className="dropdownfilter shadow-0"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterValue(e.target.value)
        }
        onSelect={(e : string | null) => setFilterValue(e ?? "")}
      >
        <Dropdown.Toggle
          className={"bi bi-funnel-fill"}
          id="dropdown-item-button"
          title="Filtre"
          variant="white"
          size="sm"
          onClickCapture={() => setColumnFiltered()}
        >
          {/* {name} */}
          {/* <i className="bi bi-funnel-fill"></i> */}
        </Dropdown.Toggle>

        <Dropdown.Menu as={SelectMenu}>
          {data.map((elem) => (
            <Dropdown.Item key={elem} eventKey={elem}>
              {elem}
            </Dropdown.Item>
          ))}
          <Dropdown.Item key={"ToutVoir"} eventKey={""}>
              Tout voir
            </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default DropdownSelector;
